export class EncodingUtil
{
    public static percentEncode(str)
    {
        return encodeURIComponent(str).replace(/[!*()']/g, (character) =>
        {
            return '%' + character.charCodeAt(0).toString(16);
        });
    };

    public static toBase64(data:string):string
    {
        return btoa(data);
    }

    public static fromBase64(base64:string):string
    {
        return atob(base64);
    }

    public static toWebSafeBase64(base64:string):string
    {
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    public static toBasicBase64(base64:string):string
    {
        return base64.replace(/\-/g, '+').replace(/_/g, '/') + '=='.substring(0, (3 * base64.length) % 4);
    }
}
